import React, { useState, useEffect } from 'react'
import "./Contact_us.css"
import Common_title from '../common/common-title/Common_title'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faClock, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import Common_download_btn from '../common/common-download-btn/Common_download_btn'
import { Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Success_Modal from '../common/common_modal/success_modal/Success_Modal'
import { useForm } from 'react-hook-form'

function Contact_us() {
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [appSetup, setAppSetup] = useState(null);
    const [appSetupLoading, setAppSetupLoading] = useState(false);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    // ── Fetch app-setup data ──
    useEffect(() => {
        fetchAppSetup();
    }, []);

    const fetchAppSetup = async () => {
        setAppSetupLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/common/masters/app-setup`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            const result = await response.json();
            if (result?.success) {
                setAppSetup(result?.data);
            }
        } catch (error) {
            console.error("App setup fetch error:", error);
        } finally {
            setAppSetupLoading(false);
        }
    };

    // ── Handle form submit ──
    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/common/masters/contact-us`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                }
            );

            const result = await response.json();

            if (result?.success) {
                setModalShow(true);
                reset();
            }
        } catch (error) {
            console.error("Contact form error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className='Contact_us section_style bg_img_holder'>
                <div className="container">
                    <Common_title headingText="Contact  " spanText="Us" />
                    <div className="form_section section_holder">
                        <div className="row">
                            <div className="col-xl-8 col-md-6">
                                <div className="heading_text_holder">
                                    <h4>Send us a Message</h4>
                                    <p>
                                        <b>Got questions or need support?</b> Our team is here to help,
                                        every step of the way. Reach out anytime we'll get back quickly.
                                    </p>
                                </div>

                                <div className="form_holder">
                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="row">

                                            {/* ── First Name ── */}
                                            <div className="col-xl-6 col-md-12 col-sm-6">
                                                <Form.Group className="mb-4">
                                                    <Form.Label>First Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter your First name"
                                                        isInvalid={!!errors.first_name}
                                                        {...register("first_name", {
                                                            required: "First name is required.",
                                                            minLength: {
                                                                value: 2,
                                                                message: "First name must be at least 2 characters."
                                                            }
                                                        })}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.first_name?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>

                                            {/* ── Last Name ── */}
                                            <div className="col-xl-6 col-md-12 col-sm-6">
                                                <Form.Group className="mb-4">
                                                    <Form.Label>Last Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter your Last name"
                                                        isInvalid={!!errors.last_name}
                                                        {...register("last_name", {
                                                            required: "Last name is required.",
                                                            minLength: {
                                                                value: 2,
                                                                message: "Last name must be at least 2 characters."
                                                            }
                                                        })}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.last_name?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>

                                            {/* ── Email ── */}
                                            <div className="col-xl-6 col-md-12 col-sm-6">
                                                <Form.Group className="mb-4">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter your Email"
                                                        isInvalid={!!errors.email}
                                                        {...register("email", {
                                                            required: "Email is required.",
                                                            pattern: {
                                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                message: "Enter a valid email address."
                                                            }
                                                        })}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.email?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>

                                            {/* ── Contact Number ── */}
                                            <div className="col-xl-6 col-md-12 col-sm-6">
                                                <Form.Group className="mb-4">
                                                    <Form.Label>Contact Number</Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        placeholder="Enter your Number"
                                                        isInvalid={!!errors.contact_no}
                                                        {...register("contact_no", {
                                                            required: "Contact number is required.",
                                                            pattern: {
                                                                value: /^\d{10}$/,
                                                                message: "Enter a valid 10-digit number."
                                                            }
                                                        })}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.contact_no?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>

                                            {/* ── Message ── */}
                                            <div className="col-md-12">
                                                <Form.Group className="mb-4">
                                                    <Form.Label>Message</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        placeholder="Enter your Message"
                                                        isInvalid={!!errors.message}
                                                        {...register("message", {
                                                            required: "Message is required.",
                                                            minLength: {
                                                                value: 10,
                                                                message: "Message must be at least 10 characters."
                                                            }
                                                        })}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.message?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className='text-end my-4'>
                                            <Common_download_btn
                                                onClick={handleSubmit(onSubmit)}
                                                btnText={loading ? "Sending..." : "Send us Message"}
                                                disabled={loading}
                                            />
                                        </div>
                                    </Form>
                                </div>
                            </div>

                            {/* ── Info Section ── */}
                            <div className="col-xl-4 col-md-6">
                                <div className="info_holder">
                                    <div className="text_holder">
                                        <p>Hi We Are Always Here <br />To Help You</p>
                                    </div>

                                    {/* ── Phone ── */}
                                    <div className="card_holder">
                                        <div className="icon_holder">
                                            <FontAwesomeIcon icon={faPhone} />
                                        </div>
                                        <div className="info_text_holder">
                                            <div>
                                                <h6>Call Us:</h6>
                                                {appSetupLoading ? (
                                                    <p>Loading...</p>
                                                ) : (
                                                    <Link to={`tel:${appSetup?.support_contact_no}`} target='_blank'>
                                                        <p>{appSetup?.support_contact_no || "N/A"}</p>
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── Email ── */}
                                    <div className="card_holder">
                                        <div className="icon_holder">
                                            <FontAwesomeIcon icon={faEnvelope} />
                                        </div>
                                        <div className="info_text_holder">
                                            <div>
                                                <h6>Email Us:</h6>
                                                {appSetupLoading ? (
                                                    <p>Loading...</p>
                                                ) : (
                                                    <Link to={`mailto:${appSetup?.support_email}`} target='_blank'>
                                                        <p>{appSetup?.support_email || "N/A"}</p>
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── Working Hours ── */}
                                    <div className="card_holder">
                                        <div className="icon_holder">
                                            <FontAwesomeIcon icon={faClock} />
                                        </div>
                                        <div className="info_text_holder">
                                            <div>
                                                <h6>Working Hours:</h6>
                                                <p>9 AM - 7:30 PM</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── Location ── */}
                                    <div className="card_holder">
                                        <div className="icon_holder">
                                            <FontAwesomeIcon icon={faLocationDot} />
                                        </div>
                                        <div className="info_text_holder">
                                            <div>
                                                <h6>Location:</h6>
                                                {appSetupLoading ? (
                                                    <p>Loading...</p>
                                                ) : (
                                                    <p>{appSetup?.location || "N/A"}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Map ── */}
                <div className="Map_holder mt-5">
                    <iframe
                        title="Location"
                        src={
                            appSetup?.location
                                ? `https://www.google.com/maps?q=${encodeURIComponent(appSetup?.location)}&output=embed`
                                : "https://maps.google.com/maps?width=600&height=400&hl=en&q=Alandi Devachi Pune-412105 ,Maharashtra, India&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        }
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </section>

            <Success_Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                successText="Submitted Successfully!"
            />
        </>
    )
}

export default Contact_us